import React, {createContext, useCallback, useContext, useState} from 'react';

interface ModalContext {
    showModal: (renderFn: (props: {show: boolean}) => React.ReactNode) => void;
    closeModal: () => void;
}

const ModalContext = createContext<ModalContext>({
    showModal: () => {},
    closeModal: () => {},
});

export const useModal = () => useContext(ModalContext);

export const ModalProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
    const [content, setContent] = useState<React.ReactNode>(null);

    const showModal = useCallback(
        (renderFn: (props: {show: boolean}) => React.ReactNode) => {
            setContent(renderFn({show: true}));
        },
        []
    );

    const closeModal = useCallback(() => {
        setContent(null);
    }, []);

    return (
        <ModalContext.Provider value={{showModal, closeModal}}>
            {children}
            {content}
        </ModalContext.Provider>
    );
};
